/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */
const original = require('../../../../packages/design-system/icon/src/index.tsx');

const _inlined0 = (() => { const module = { exports: {} }; const exports = module.exports; (function () {
/**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */
const React = require('react');

function Icon(props) {
	const {
		glyph: Glyph,
		dangerouslySetGlyph,
		primaryColor,
		testId,
		label,
	} = props;

	if (Glyph) {
		return React.createElement(Glyph, {
			role: label ? 'img' : 'presentation',
			'aria-label': label || undefined,
			'aria-hidden': label ? undefined : 'true',
			'data-testid': testId,
			fill: primaryColor || 'currentColor',
		});
	}

	if (dangerouslySetGlyph) {
		return React.createElement('span', {
			dangerouslySetInnerHTML: { __html: dangerouslySetGlyph },
			role: label ? 'img' : undefined,
			'aria-label': label || undefined,
			'aria-hidden': label ? undefined : 'true',
			'data-testid': testId,
			style: {
				display: 'inline-block',
				lineHeight: 1,
				color: primaryColor || 'currentColor',
			},
		});
	}

	return null;
}

Icon.displayName = 'Icon';

module.exports = Icon;

})(); return module.exports; })();

module.exports = Object.assign({}, original, {
	default: _inlined0,
});

if (original.__esModule) Object.defineProperty(module.exports, '__esModule', { value: true });
